import { __ } from '@wordpress/i18n';
import { __experimentalBlockVariationPicker as BlockVariationPicker, useBlockProps } from '@wordpress/block-editor';
import { useDispatch } from '@wordpress/data';
import { createBlocksFromInnerBlocksTemplate } from '@wordpress/blocks';
// import { Path, SVG } from '@wordpress/components';
import { RxGroup as icons } from "react-icons/rx";

import {
	Defs,
	G,
	Path,
	Rect,
	SVG,
	clipPath
} from '@wordpress/primitives';

const columnWidth = 9;  // Width of each column
const columnSpacing = 5;  // Space between columns
const columns = 4;  // Number of columns

// Calculate total width
const totalWidth = columns * columnWidth + (columns - 1) * columnSpacing;
export const variations = [
	{
		name: 'one-column-join',
        icon: (
			<SVG
				xmlns="http://www.w3.org/2000/svg"
				width="64"
				height="64"
				viewBox="0 0 48 48"
			>
				<Path d="M0 10a2 2 0 0 1 2-2h44a2 2 0 0 1 2 2v28a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V10Z" />
			</SVG>
		),
		attributes: {
			variationSelected: true,
		},
		scope: [ 'block' ],
	},
	{
		name: 'two-column-join',
        icon: (
			<SVG
				xmlns="http://www.w3.org/2000/svg"
				width="64"
				height="64"
				viewBox="0 0 48 48"
			>
				<Path d="M0 10a2 2 0 0 1 2-2h19a2 2 0 0 1 2 2v28a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V10Zm25 0a2 2 0 0 1 2-2h19a2 2 0 0 1 2 2v28a2 2 0 0 1-2 2H27a2 2 0 0 1-2-2V10Z" />
			</SVG>
		),
		attributes: {
			variationSelected: true,
			contFlex:{
				direction:{
					Desktop: "row",
					Tablet: "row",
					Mobile: "column"
				}
			   },
			   rwGap: {
				Desktop: "18px",
				Tablet: "18px",
				Mobile: "18px"
			},
			  colGap: {
				Desktop: "18px",
				Tablet: "18px",
				Mobile: "18px"
			}
		},
		isDefault: true,
		innerBlocks: [
			[ 'vayu-blocks/advance-container',{ contentWidthType: "fullwidth", 
			   fullcontentWidth: {
						Desktop: "50%",
						Tablet: "50%",
						Mobile: "100%"
					}
				 }],
			[ 'vayu-blocks/advance-container',{ contentWidthType: "fullwidth", fullcontentWidth: {
				Desktop: "50%",
				Tablet: "50%",
				Mobile: "100%"
			} }],
		],
		scope: [ 'block' ],
	},
	{
		name: 'three-columns-equal-join',
        icon: (
			<SVG
				xmlns="http://www.w3.org/2000/svg"
				width="64"
				height="64"
				viewBox="0 0 48 48"
			>
				<Path d="M0 10a2 2 0 0 1 2-2h10.531c1.105 0 1.969.895 1.969 2v28c0 1.105-.864 2-1.969 2H2a2 2 0 0 1-2-2V10Zm16.5 0c0-1.105.864-2 1.969-2H29.53c1.105 0 1.969.895 1.969 2v28c0 1.105-.864 2-1.969 2H18.47c-1.105 0-1.969-.895-1.969-2V10Zm17 0c0-1.105.864-2 1.969-2H46a2 2 0 0 1 2 2v28a2 2 0 0 1-2 2H35.469c-1.105 0-1.969-.895-1.969-2V10Z" />
			</SVG>
		),
		attributes: {
			variationSelected: true,
			contFlex:{
				direction:{
					Desktop: "row",
					Tablet: "row",
					Mobile: "column"
				}
			   } 
		},
		innerBlocks: [
			[ 'vayu-blocks/advance-container',{ contentWidthType: "fullwidth", fullcontentWidth: {
						Desktop: "33.33%",
						Tablet: "33.33%",
						Mobile: "100%"
					} }],
			[ 'vayu-blocks/advance-container',{ contentWidthType: "fullwidth", fullcontentWidth: {
						Desktop: "33.33%",
						Tablet: "33.33%",
						Mobile: "100%"
					} }],
			[ 'vayu-blocks/advance-container',{ contentWidthType: "fullwidth", fullcontentWidth: {
						Desktop: "33.33%",
						Tablet: "33.33%",
						Mobile: "100%"
					} }],
		],
		scope: [ 'block' ],
	},
	{
		name: 'four-column-join',
        icon: ( 
			<SVG
			xmlns="http://www.w3.org/2000/svg"
			width="64"
			height="64"
			viewBox={`0 0 ${totalWidth} 48`}
			>
  {[...Array(columns)].map((_, i) => {
    const xPos = i * (columnWidth + columnSpacing);
    return (
      <Path
        key={i}
        d={`M${xPos} 10a2 2 0 0 1 2-2h${columnWidth - 2}c1.105 0 2 .895 2 2v28c0 1.105-.895 2-2 2H${xPos + 2}a2 2 0 0 1-2-2V10Z`}
      />
    );
  })}
</SVG>  
		),
		attributes: {
			variationSelected: true,
			contFlex:{
				direction:{
					Desktop: "row",
					Tablet: "row",
					Mobile: "column"
				}
			   } 
		},
		isDefault: true,
		innerBlocks: [
			[ 'vayu-blocks/advance-container'],
			[ 'vayu-blocks/advance-container'],
			[ 'vayu-blocks/advance-container'],
			[ 'vayu-blocks/advance-container'],
		],
		scope: [ 'block' ],
	},
	{
		name: 'two-column-33-66',
        icon: (
			<SVG
				xmlns="http://www.w3.org/2000/svg"
				width="64"
				height="64"
				viewBox="0 0 48 48"
			>
				<Path d="M0 10a2 2 0 0 1 2-2h11a2 2 0 0 1 2 2v28a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V10Zm17 0a2 2 0 0 1 2-2h27a2 2 0 0 1 2 2v28a2 2 0 0 1-2 2H19a2 2 0 0 1-2-2V10Z" />
			</SVG>
		),
		attributes: {
			variationSelected: true,
			contFlex:{
				direction:{
					Desktop: "row",
					Tablet: "row",
					Mobile: "column"
				}
			   }
		},
		isDefault: true,
		innerBlocks: [
			[ 'vayu-blocks/advance-container', { 
				contentWidthType: "fullwidth", 
				fullcontentWidth: {
						Desktop: "33%",
						Tablet: "33%",
						Mobile: "100%"
					}
			}],
			[ 'vayu-blocks/advance-container' ,{ 
				contentWidthType:"fullwidth",
				fullcontentWidth: {
						Desktop: "66%",
						Tablet: "66%",
						Mobile: "100%"
					}
			 }],
		],
		scope: [ 'block' ],
	},
	{
		name: 'three-column-25-50-25',
        icon: (
			<SVG
				xmlns="http://www.w3.org/2000/svg"
				width="64"
				height="64"
				viewBox="0 0 48 48"
			>
				<Path d="M0 10a2 2 0 0 1 2-2h7.531c1.105 0 1.969.895 1.969 2v28c0 1.105-.864 2-1.969 2H2a2 2 0 0 1-2-2V10Zm13.5 0c0-1.105.864-2 1.969-2H32.53c1.105 0 1.969.895 1.969 2v28c0 1.105-.864 2-1.969 2H15.47c-1.105 0-1.969-.895-1.969-2V10Zm23 0c0-1.105.864-2 1.969-2H46a2 2 0 0 1 2 2v28a2 2 0 0 1-2 2h-7.531c-1.105 0-1.969-.895-1.969-2V10Z" />
			</SVG>
		),
		attributes: {
			variationSelected: true,
			contFlex:{
				direction:{
					Desktop: "row",
					Tablet: "row",
					Mobile: "column"
				}
			   } 
		},
		isDefault: true,
		innerBlocks: [
			[ 'vayu-blocks/advance-container', { contentWidthType: "fullwidth", fullcontentWidth: {
						Desktop: "25%",
						Tablet: "25%",
						Mobile: "100%"
					} }],
			[ 'vayu-blocks/advance-container' ,{ contentWidthType:"fullwidth",  fullcontentWidth:{
						Desktop: "50%",
						Tablet: "50%",
						Mobile: "100%"
					}}],
			[ 'vayu-blocks/advance-container' ,{ contentWidthType:"fullwidth",  fullcontentWidth: {
						Desktop: "25%",
						Tablet: "25%",
						Mobile: "100%"
					}}],
		],
		scope: [ 'block' ],
	},
	{
		name: '2*2-column-50-50',
        icon: (
			<SVG
				xmlns="http://www.w3.org/2000/svg"
				width="64"
				height="64"
				viewBox="0 0 48 48"
			>
				<Path d="M0 10a2 2 0 0 1 2-2h19a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V10Zm25 0a2 2 0 0 1 2-2h19a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H27a2 2 0 0 1-2-2V10ZM0 27a2 2 0 0 1 2-2h19a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V27Zm25 0a2 2 0 0 1 2-2h19a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H27a2 2 0 0 1-2-2V27Z" />
			</SVG>
		),
		attributes: {
			variationSelected: true,
			contFlex:{
				direction:{
					Desktop: "column",
					Tablet: "column",
					Mobile: "column"
				}
			   }
			
		},
		isDefault: true,
		innerBlocks: [
			[
				'vayu-blocks/advance-container',
				{ contFlex:{
					direction:{
						Desktop: "row",
						Tablet: "row",
						Mobile: "column"
					}
				   }  },
				[
					[ 'vayu-blocks/advance-container', { contentWidthType: "fullwidth", fullcontentWidth: {
						Desktop: "50%",
						Tablet: "50%",
						Mobile: "100%"
					} } ],
					[ 'vayu-blocks/advance-container', { contentWidthType: "fullwidth", fullcontentWidth: {
						Desktop: "50%",
						Tablet: "50%",
						Mobile: "100%"
					} } ],
				],
			],
			[
				'vayu-blocks/advance-container',
				{ contFlex:{
					direction:{
						Desktop: "row",
						Tablet: "row",
						Mobile: "column"
					}
				   }  },
				[
					[ 'vayu-blocks/advance-container', { contentWidthType: "fullwidth", fullcontentWidth: {
						Desktop: "50%",
						Tablet: "50%",
						Mobile: "100%"
					} } ],
					[ 'vayu-blocks/advance-container', { contentWidthType: "fullwidth", fullcontentWidth: {
						Desktop: "50%",
						Tablet: "50%",
						Mobile: "100%"
					} } ],
				],
			],
		],
		scope: [ 'block' ],
	},
	{
		name: '2*3-column-33-33-33',
        icon: (
			<SVG xmlns="http://www.w3.org/2000/svg" width="60" height="32" viewBox="0 0 72 48" ariaHidden="true" focusable="false"> 
			<Path d=" M2 4 A2 2 0 0 1 4 2 H20 A2 2 0 0 1 22 4 V20 A2 2 0 0 1 20 22 H4 A2 2 0 0 1 2 20 Z M26 4 A2 2 0 0 1 28 2 H44 A2 2 0 0 1 46 4 V20 A2 2 0 0 1 44 22 H28 A2 2 0 0 1 26 20 Z M50 4 A2 2 0 0 1 52 2 H68 A2 2 0 0 1 70 4 V20 A2 2 0 0 1 68 22 H52 A2 2 0 0 1 50 20 Z M2 27 A2 2 0 0 1 4 25 H20 A2 2 0 0 1 22 27 V43 A2 2 0 0 1 20 45 H4 A2 2 0 0 1 2 43 Z M26 27 A2 2 0 0 1 28 25 H44 A2 2 0 0 1 46 27 V43 A2 2 0 0 1 44 45 H28 A2 2 0 0 1 26 43 Z M50 27 A2 2 0 0 1 52 25 H68 A2 2 0 0 1 70 27 V43 A2 2 0 0 1 68 45 H52 A2 2 0 0 1 50 43 Z " /> 
			</SVG>
		),
		attributes: {
			variationSelected: true,
			
			contFlex:{
				direction:{
					Desktop: "column",
					Tablet: "column",
					Mobile: "column"
				}
			   }
			
		},
		isDefault: true,
		innerBlocks: [
			[
				'vayu-blocks/advance-container',
				{  contFlex:{
					direction:{
						Desktop: "row",
						Tablet: "row",
						Mobile: "column"
					}
			     }, 
			    },
				[
					[ 'vayu-blocks/advance-container', { contentWidthType: "fullwidth", fullcontentWidth: {
						Desktop: "33%",
						Tablet: "33%",
						Mobile: "100%"
					} } ],
					[ 'vayu-blocks/advance-container', { contentWidthType: "fullwidth", fullcontentWidth:{
						Desktop: "33%",
						Tablet: "33%",
						Mobile: "100%"
					}} ],
					[ 'vayu-blocks/advance-container', { contentWidthType: "fullwidth", fullcontentWidth:{
						Desktop: "33%",
						Tablet: "33%",
						Mobile: "100%"
					} } ],
				],
			],
			[
				'vayu-blocks/advance-container',
				{ contFlex:{
					direction:{
						Desktop: "row",
						Tablet: "row",
						Mobile: "column"
					}
				   }  },
				[
					[ 'vayu-blocks/advance-container', { contentWidthType: "fullwidth", fullcontentWidth:{
						Desktop: "33%",
						Tablet: "33%",
						Mobile: "100%"
					} } ],
					[ 'vayu-blocks/advance-container', { contentWidthType: "fullwidth", fullcontentWidth:{
						Desktop: "33%",
						Tablet: "33%",
						Mobile: "100%"
					} } ],
					[ 'vayu-blocks/advance-container', { contentWidthType: "fullwidth", fullcontentWidth:{
						Desktop: "33%",
						Tablet: "33%",
						Mobile: "100%"
					}} ],
				],
			],
		],
		scope: [ 'block' ],
	},
	
];

export const VariationPicker = ( { clientId, setAttributes, defaultVariation } ) => {
	
	const { replaceInnerBlocks } = useDispatch( 'core/block-editor' );

	const blockVariationPickerOnSelect = ( nextVariation = defaultVariation ) => {
		if ( nextVariation.attributes ) {
			setAttributes( nextVariation.attributes );
		}

		if ( nextVariation.innerBlocks && 'one-column-join' !== nextVariation.name ) {
			replaceInnerBlocks( clientId, createBlocksFromInnerBlocksTemplate( nextVariation.innerBlocks ) );
		}
	};

	return (
		<div {...useBlockProps()} className="vayu-blocks-container-variation-picker">
			<BlockVariationPicker
				icon= {icons}
				label={ __( 'Container', 'vayu-blocks' ) }
				instructions={
					__(
						'Choose your desired layout',
						'vayu-blocks'
					)
				}
				variations={ variations }
				onSelect={ ( nextVariation ) => blockVariationPickerOnSelect( nextVariation ) }
			/>
		</div>
	);
};
